import { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import useFileUpload from "../../../utils/hooks/useFileUpload";
import { useDispatch } from "react-redux";
import {
  removeUploadedDocUrl,
  setUploadedDocUrl,
} from "../../../redux/slice/migration/migrationSlice";
import useCopyToClipboard from "../../../utils/hooks/useCopyToClipboard";
import { useSelector } from "react-redux";
import { flashMessage } from "../../../utils/flash";

const DocUploadPage = () => {
  const { uploadedDocUrl } = useSelector((state) => state.migration);
  const fileTypes = ["JPG", "PNG", "JPEG", "PDF", "DOC", "DOCX"];

  const [selectedFile, setSelectedFile] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const { fileUrl, singleFileUpload } = useFileUpload();
  const { feedback, copyToClipboard } = useCopyToClipboard();

  const dispatch = useDispatch();

  const handleFileChange = (file) => {
    setIsUploading(true);
    setSelectedFile(file);
    if (file.size / (1024 * 1024) > 1) {
      flashMessage("error", "File is too large");
    }
    singleFileUpload(file);
    dispatch(removeUploadedDocUrl(""));
  };

  useEffect(() => {
    if (fileUrl) {
      setIsUploading(false);
      dispatch(setUploadedDocUrl(fileUrl));
    }
  }, [fileUrl]);

  return (
    <div className='mx-auto mb-5 w-75 '>
      <h1 className='text-center mt-3'>Document Upload</h1>
      <div className='row mt-5 mb-4'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body border '>
              <h4 className='fw-semibold text-primary-1 bg-whit position-absolute profile-title border'>
                Upload Document
              </h4>
              <div className='alert alert-info mt-2'>
                Document must be in the format{" "}
                <span className='text-warning'>png, jpeg, jpg and pdf</span>{" "}
                only
              </div>
              <div className='row my-4 document-upload'>
                <div className='col-md-3'>
                  <label
                    htmlFor='inputEmail4'
                    className='form-label d-block uploader-label'
                  >
                    Upload Document
                    <span className='text-danger'>*</span>
                    {isUploading && (
                      <span className='ms-1 text-danger'>
                        {" "}
                        <i
                          className={`mdi mdi-dots-circle mdi-spin fs-5 h3 mt-0`}
                        ></i>{" "}
                      </span>
                    )}
                    {!isUploading && fileUrl && (
                      <span className='bg-dar ms-1 text-success'>
                        {" "}
                        <i className={`mdi mdi-check fs-5 h3 mt-0`}></i>{" "}
                      </span>
                    )}
                  </label>
                  <FileUploader
                    label=' Browse Passport'
                    children={
                      <div
                        className='borde border-dotted p-1 px-2 text-center cursor-p mt-0 uploader'
                        style={{ border: "2px dashed grey" }}
                        // onClick={handleFileChange}
                        // onDrop={handleFileChange}
                      >
                        <i className='uil uil-cloud-upload fs-4'></i> Upload
                        Document
                        <span className='text-primary-dark mt-0'></span>
                      </div>
                    }
                    handleChange={handleFileChange}
                    onDrop={handleFileChange}
                    name='file'
                    types={fileTypes}
                  />
                </div>

                <div className='col-md-7 sm-mt-3'>
                  <label htmlFor='inputEmail4' className='form-label d-block'>
                    Uploaded Document URL{" "}
                  </label>
                  <input
                    type='text'
                    value={uploadedDocUrl}
                    className='form-control input-copy'
                  />
                </div>
                <div className='position-relative col-md-1 d-flex align-items-center'>
                  {feedback && (
                    <div
                      className='position-absolute badge badge-success-lighten p-1'
                      style={{ top: "-7px" }}
                    >
                      <div className='position-relative'>
                        <span className=''>Copied</span>
                      </div>
                    </div>
                  )}
                  <button
                    className='btn btn-sm btn-info mt-3 copy'
                    onClick={() => copyToClipboard(uploadedDocUrl)}
                  >
                    Copy
                  </button>
                </div>
              </div>
              {/* {selectedFile && (
                <img
                  width={100}
                  height={100}
                  className='mt-2 ms-2'
                  src={URL.createObjectURL(selectedFile)}
                  alt=''
                />
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocUploadPage;
